import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss'],
  standalone: false
})
export class EmailConfirmationComponent implements OnInit {
  
  confirmationStatus: string = '';
  isLoading: boolean = true;
  success: boolean = false;
  invalidToken: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.authService.verifyEmail(token).subscribe((result) => {
          this.confirmationStatus = result.message;
          this.success = true;
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
          this.invalidToken = true;
        });
      } else {
        this.invalidToken = true;
      }
    });
  }

  continueWithLogin() {
    this.router.navigate(['/login']);
  }
}